const dbBodyFonts = [
    { key: "default", value: "System Default", font: "inherit" },
    { key: "clean", value: "Clean and Modern (Arial)", font: "Arial, Helvetica, sans-serif" },
    { key: "friendly", value: "Friendly and Soft (Verdana)", font: "Verdana, Geneva, sans-serif" },
    { key: "monospace", value: "Monospace (Courier New)", font: "'Courier New', Courier, monospace" },
];
export default dbBodyFonts;